import { J as JsonEncoder } from "../../../../../../../../../chunks/JsonEncoder.js";
import { l as logger } from "../../../../../../../../../chunks/logger.js";
import { g as getMongo } from "../../../../../../../../../chunks/mongo.js";
const load = async ({ params, depends }) => {
  depends("app:indexes");
  const mongo = await getMongo();
  const client = mongo.getClient(params.server);
  const collection = client.db(params.database).collection(params.collection);
  const indexesPromise = (async () => {
    try {
      const indexList = await collection.listIndexes().toArray();
      client.setIndexes(
        params.database,
        params.collection,
        indexList.map((index) => ({ name: index.name, key: index.key }))
      );
      let indexStats = {};
      try {
        const statsResult = await collection.aggregate([{ $indexStats: {} }]).toArray();
        indexStats = Object.fromEntries(
          statsResult.map((stat) => [
            stat.name,
            {
              ops: stat.accesses?.ops || 0,
              since: stat.accesses?.since || /* @__PURE__ */ new Date()
            }
          ])
        );
      } catch (err) {
        logger.error("Error fetching index stats:", err);
      }
      const buildingIndexes = {};
      try {
        const currentOp = await client.db("admin").command({
          currentOp: true,
          "command.createIndexes": params.collection,
          $or: [{ "command.$db": params.database }, { ns: `${params.database}.${params.collection}` }]
        });
        for (const op of currentOp.inprog || []) {
          const indexes = op.command?.indexes || [];
          const progress = op.progress;
          const pct = progress && progress.total > 0 ? Math.round(progress.done / progress.total * 100) : 0;
          for (const idx of indexes) {
            if (idx.name) {
              buildingIndexes[idx.name] = {
                done: progress?.done ?? 0,
                total: progress?.total ?? 0,
                pct,
                key: idx.key
              };
            }
          }
        }
      } catch (err) {
        logger.error("Error fetching currentOp for building indexes:", err);
      }
      let indexSizes = {};
      try {
        const collStatsResult = await collection.aggregate([
          {
            $collStats: {
              storageStats: {}
            }
          }
        ]).next();
        if (collStatsResult?.storageStats?.indexSizes) {
          indexSizes = collStatsResult.storageStats.indexSizes;
        }
      } catch (err) {
        logger.error("Error fetching index sizes:", err);
      }
      const indexesWithStats = indexList.map((index) => ({
        ...index,
        stats: index.name ? indexStats[index.name] || null : null,
        size: index.name ? indexSizes[index.name] || 0 : 0,
        building: index.name ? buildingIndexes[index.name] || null : null
      }));
      return {
        data: indexesWithStats.map((index) => JsonEncoder.encode(index)),
        error: null
      };
    } catch (err) {
      logger.error("Error fetching indexes:", err);
      return {
        data: [],
        error: `Failed to fetch indexes: ${err instanceof Error ? err.message : String(err)}`
      };
    }
  })();
  return {
    indexes: indexesPromise
  };
};
export {
  load
};
